var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'item-show-field switch-field d-inline-block'},[_c('v-switch',{attrs:{"label":_vm.label,"color":"green darken-2","disabled":_vm.readOnly,"hide-details":"","dense":""},model:{value:(_vm.valueComputed),callback:function ($$v) {_vm.valueComputed=$$v},expression:"valueComputed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }